// extracted by mini-css-extract-plugin
module.exports = {"item-notes":"item-notes__3Qb0a"};